import { SystemStyleObject } from '@chakra-ui/react';

interface StorageComponentSxType {
  title: SystemStyleObject;
}

const getTitleColor = (isActive: boolean, isPlayerTheme: boolean) => {
  if (isPlayerTheme) {
    return isActive ? 'P.80' : 'textBase';
  }
  return isActive ? 'P.80' : 'textBase';
};

export const getAudioTitleSx = (
  isActive: boolean,
  isPlayerTheme: boolean
): StorageComponentSxType => ({
  title: {
    color: getTitleColor(isActive, isPlayerTheme),
  },
});
